import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { BRAND_TEXTURE } from "@/constants/images";

const TITLES = {
    "/carotare": "CAROTARE",
    "/demolari-taiere": "DEMOLĂRI / TĂIERI",
    "/slefuire": "ȘLEFUIRE",
    "/repastilare-carote": "REPASTILARE CAROTE",
    "/contact": "CONTACT",
};

export default function PlaceholderPage() {
    const { pathname } = useLocation();
    const title = TITLES[pathname] || "PAGINĂ";

    return (
        <main className="relative flex min-h-screen flex-col justify-center overflow-hidden px-5 pb-24 pt-32 lg:px-10">
            <img
                src={BRAND_TEXTURE}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover opacity-20"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/90 to-ink" />

            <div className="relative z-10 mx-auto w-full max-w-[1600px]">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                >
                    <div className="flex items-center gap-4">
                        <span className="h-[2px] w-10 bg-flame" />
                        <span className="font-mono-tech text-[11px] tracking-[0.3em] text-mist">
                            CAROTE.RO — ÎN CURÂND
                        </span>
                    </div>

                    <h1 className="mt-8 font-display text-[clamp(1.9rem,4.5vw,4.2rem)] font-extrabold uppercase leading-none tracking-tight text-paper">
                        {title}
                    </h1>

                    <p className="mt-8 max-w-xl text-sm leading-relaxed text-mist sm:text-base">
                        Această pagină este în dezvoltare. Structura și
                        linkurile sunt deja pregătite pentru conținutul complet
                        al serviciului.
                    </p>

                    <Link
                        to="/"
                        data-testid="placeholder-back-home"
                        className="group mt-12 inline-flex w-fit items-center gap-3 border border-paper/25 px-7 py-4 font-mono-tech text-xs font-bold tracking-[0.2em] text-paper transition-all duration-300 hover:border-flame hover:text-flame"
                    >
                        <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1.5" />
                        ÎNAPOI PE PAGINA PRINCIPALĂ
                    </Link>
                </motion.div>
            </div>
        </main>
    );
}